// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__udbkp","colMin":"styles_colMin__2AN3l"};